export default "__VITE_ASSET__8d451546__"